import { template as template_6bb719260e6e42f1ae61b314f011f088 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import { fn } from '@ember/helper';
import { isPresent, isEmpty } from '@ember/utils';
import { task } from 'ember-concurrency';
import { t } from 'ember-intl';
import { or, not } from 'ember-truth-helpers';
import onKey from 'ember-keyboard/modifiers/on-key';
import { buildValidations, validator } from '@eflexsystems/ember-tracked-validations';
import BsForm from 'eflex/components/bs-form';
import BsButton from 'eflex/components/bs-button';
import StandardModal from 'eflex/components/standard-modal';
@buildValidations({
    employeeId: [
        validator('inline', {
            validate (employee, options, modal) {
                if (!modal.employee) {
                    return modal.intl.t('kinetic.invalidEmployee');
                }
                return true;
            }
        })
    ]
})
class KineticEmployeeModal extends Component {
    @service
    kineticShiftRepo;
    @service
    kineticEmployeeRepo;
    @service
    intl;
    @tracked
    employeeId;
    @tracked
    employee;
    @tracked
    shift;
    setEmployee = task(waitFor(async ()=>{
        if (isEmpty(this.employeeId)) {
            return;
        }
        this.employee = await this.kineticEmployeeRepo.getEmployee.perform(this.employeeId);
        if (!this.employee) {
            this.shift = null;
            return;
        }
        this.shift = this.employee.currentShift ?? this.employee.defaultShift;
    }));
    get isInvalid() {
        return this.validations?.isInvalid ?? false;
    }
    static{
        template_6bb719260e6e42f1ae61b314f011f088(`
    <StandardModal
      @onCancel={{@onCancel}}
      @onConfirm={{fn @onConfirm this.employee this.shift}}
      @size="sm"
      class="employee-login-modal"
    as |modal|>
      <modal.header @text={{t "controls.login.login"}} />
      <modal.body>
        <BsForm @model={{this}} as |form|>
          <div class="row">
            <div class="col">
              <form.element
                @controlType="text"
                @property="employeeId"
                @label={{t "kinetic.employeeId"}}
                class="employee-id"
                {{onKey "Enter" this.setEmployee.perform}}
              />
            </div>
            <div class="col-auto align-self-end">
              <BsButton
                @onClick={{this.setEmployee.perform}}
                @disabled={{not this.employeeId}}
                class="submit-id"
              >
                {{t "submit"}}
              </BsButton>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <form.element
                @controlType="text"
                @property="name"
                @label={{t "name"}}
                @model={{this.employee}}
                class="employee-name"
              as |el|>
                <el.control @disabled={{true}}/>
              </form.element>
            </div>
            <div class="col">
              <form.element
                @controlType="power-select"
                @label={{t "kinetic.shiftId"}}
                @options={{this.kineticShiftRepo.kineticShifts}}
                @optionLabelPath="displayName"
                @property='shift'
                class="shift-select"
              as |el|>
                <el.control
                  @disabled={{or (not this.employee) (isPresent this.employee.currentShift)}}
                  @placeholder={{t "kinetic.selectShift"}}
                />
              </form.element>
            </div>
          </div>
        </BsForm>

      </modal.body>
      <modal.footer as |footer|>
        <footer.confirm @disabled={{or (not this.employee) (not this.shift)}} />
        <footer.close />
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default KineticEmployeeModal;
